export default __webpack_public_path__ + "static/media/google@2x.edbc81ae.jpg";